export default {
	mounted(el, binding) {
		if (typeof binding.value !== "function")
			return;

		let swipeStart = null;

		el.ontouchstart = (event) => {
			if (event.touches.length === 1)
				swipeStart = event.touches.item(0).clientX;
			else
				swipeStart = null;
		};

		el.ontouchend = (event) => {
			if (swipeStart === null)
				return;

			const distance = swipeStart - event.changedTouches.item(0).clientX;

			swipeStart = null;

			if (distance > 60)
				binding.value(true);

			if (distance < -60)
				binding.value(false);
		};
	},
	unmounted(el) {
		el.ontouchstart = null;
		el.ontouchend = null;
	}
};
